import { send } from 'server';

export const fetchUserDetails = (playerFields, networkTypes, networkDataFilters) => send({
    ID: 31082,
    responses: [31083, 31084],
    description: 'Get player info',
    requestType: 'marked',
    returnContactPreferences: true,
    requestedPlayerData: playerFields,
    requestedNetworkTypes: networkTypes,
    playerNetworkDataFilters: networkDataFilters
});

export const getURLsRequest = options => send({
    ID: 35844,
    responses: [31032, 31033],
    description: 'Get URLs Request',
    casinoName: options.casinoName,
    clientSkinName: options.clientSkin,
    clientType: options.clientType,
    clientPlatform: options.clientPlatform,
    urlTypeList: options.urlTypeList
});

export const getTwoFactorConf = ({ casinoName }) => send({
    ID: 35757,
    casino: casinoName,
    description: 'Get Two Factor Conf',
    responses: [35758, 35759]
});
